import React, {memo} from 'react';
import {
  FlatList,
  PixelRatio,
  StyleProp,
  StyleSheet,
  Text,
  View,
  ViewStyle,
} from 'react-native';

import {getDescriber} from './descriptor/DescriptorType';
import Styles from '../../Styles';
import {IMenuCategory} from '../../../types/ProductCategory';
import DashedLine from 'react-native-dashed-line';
import {getDescriber as getSnackDescriber} from 'src/components/screens/sendSnack/descriptor/sendasnack/DescriptorType';

type MenuItemsCategoriesProps = {
  menuItems: Array<IMenuCategory>;
  selectedCategory: string | number;
  onMenuItemPress: (
    category: IMenuCategory,
    isPlusIconPressed?: boolean,
  ) => void;
  style: StyleProp<ViewStyle>;
};

export const QuickAddOns = memo(
  ({
    menuItems,
    selectedCategory,
    onMenuItemPress,
    style,
  }: MenuItemsCategoriesProps) => {
    const renderItem = ({
      item,
      index,
    }: {
      item: IMenuCategory;
      index: number;
    }) => {
      return getDescriber()?.menuItemCategoryRenderItem({
        item,
        index,
        selectedCategory: selectedCategory,
        categoriesLength: menuItems.length,
        onMenuItemPress: onMenuItemPress,
      });
    };

    return (
      <View>
        <DashedLine
          dashGap={PixelRatio.roundToNearestPixel(2)}
          dashLength={PixelRatio.roundToNearestPixel(3)}
          dashThickness={PixelRatio.roundToNearestPixel(1)}
          dashColor={Styles.Colors.PayNew.neutralHuesBase09}
          style={styles.dashStyleTop}
        />
        <Text
          nativeID={'Quick Add Ons'}
          maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm8}
          style={[styles.title, getSnackDescriber().snackDetailsBtnFontSTyle()]}
        >
          Quick Add Ons
        </Text>
        <FlatList
          style={style}
          data={menuItems}
          renderItem={renderItem}
          horizontal={true}
          keyExtractor={(item) => `${item.key}`}
        />
        <DashedLine
          dashGap={PixelRatio.roundToNearestPixel(2)}
          dashLength={PixelRatio.roundToNearestPixel(3)}
          dashThickness={PixelRatio.roundToNearestPixel(1)}
          dashColor={Styles.Colors.PayNew.neutralHuesBase09}
          style={styles.dashStyleBottom}
        />
      </View>
    );
  },
);

const styles = StyleSheet.create({
  title: {
    fontSize: Styles.Fonts.f1,
    marginLeft: Styles.Spacing.m3,
    marginBottom: Styles.Spacing.m3,
    marginTop: Styles.Spacing.m2,
    fontWeight: 'bold',
  },
  dashStyleTop: {
    marginLeft: Styles.Spacing.m3,
    marginRight: Styles.Spacing.m3,
    marginTop: -Styles.Spacing.m1,
  },
  dashStyleBottom: {
    marginLeft: Styles.Spacing.m3,
    marginRight: Styles.Spacing.m3,
    marginBottom: Styles.Spacing.m3,
  },
});
